import { useCallback } from "react";

import {
    useFastshiftAnalyticsData,
    useFireAnalyticsEvents
} from "@/components/fastshift/analytics";
import {
    ActionKey,
    ActionSubjectKey,
    ActionSubjectIdKey
} from "@/components/fastshift/analytics/constants";

export const useFastshiftUIAnalytics = () => {
    const { sourceKey, identityAttrs } = useFastshiftAnalyticsData(true);
    const { fireUIEvent } = useFireAnalyticsEvents(identityAttrs);

    const sendGoBackButtonClickUIEvent = useCallback(() => {
        fireUIEvent({
            action: ActionKey.CLICKED,
            actionSubject: ActionSubjectKey.BUTTON,
            actionSubjectId: ActionSubjectIdKey.GO_BACK_BUTTON,
            source: sourceKey,
            attributes: {}
        });
    }, [fireUIEvent, sourceKey]);

    const sendSignInWithAnotherAccountButtonClickUIEvent = useCallback(() => {
        fireUIEvent({
            action: ActionKey.CLICKED,
            actionSubject: ActionSubjectKey.BUTTON,
            actionSubjectId:
                ActionSubjectIdKey.SIGN_IN_WITH_ANOTHER_ACCOUNT_BUTTON,
            source: sourceKey,
            attributes: {}
        });
    }, [fireUIEvent, sourceKey]);

    const sendContactSupportLinkClickUIEvent = useCallback(() => {
        fireUIEvent({
            action: ActionKey.CLICKED,
            actionSubject: ActionSubjectKey.LINK,
            actionSubjectId: ActionSubjectIdKey.CONTACT_SUPPORT_LINK,
            source: sourceKey,
            attributes: {}
        });
    }, [fireUIEvent, sourceKey]);

    return {
        sendGoBackButtonClickUIEvent,
        sendSignInWithAnotherAccountButtonClickUIEvent,
        sendContactSupportLinkClickUIEvent
    };
};
